import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Network, ShieldCheck, Zap, Maximize } from 'lucide-react';
const cards = [{
  title: 'Workflow Intelligence',
  description: 'AI that maps to your real business processes, not just generic chat.',
  icon: Network
}, {
  title: 'Operational Context',
  description: 'Understands compliance, SLAs, business rules, and the language of your industry.',
  icon: ShieldCheck
}, {
  title: 'Faster Decisions',
  description: 'Real-time reasoning and actioning that reduce admin bottlenecks.',
  icon: Zap
}, {
  title: 'Scalable Operations',
  description: 'Deploy from one workflow to enterprise-wide use cases with consistency.',
  icon: Maximize
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 30
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: [0.25, 0.1, 0.25, 1]
    }
  }
};
export function ValueProp() {
  return <section id="about" className="py-32 bg-brand-black relative z-10" data-id="element-517">
      <div className="max-w-7xl mx-auto px-6" data-id="element-518">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.25, 0.1, 0.25, 1]
      }} className="text-center mb-24" data-id="element-519">
          <h2 className="font-display text-4xl md:text-5xl text-white mb-6 tracking-tight" data-id="element-520">
            Vertical Intelligence, <br className="hidden md:block" data-id="element-521" />
            <span className="text-gray-500" data-id="element-522">Purpose-Built.</span>
          </h2>
          <p className="font-body text-lg text-gray-400 max-w-2xl mx-auto" data-id="element-523">
            Aijentik creates deeply vertical AI agents that understand your
            workflows, compliance requirements, operational logic, and customer
            journeys.
          </p>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-524">
          {cards.map((card, index) => <motion.div key={index} variants={itemVariants} className="relative group h-full" data-id="element-525">
              <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent rounded-3xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-526" />
              <div className="bg-[#0A0A0A] border border-white/5 rounded-3xl p-8 h-full relative z-10 transition-all duration-500 group-hover:-translate-y-1 group-hover:border-white/10 group-hover:shadow-[0_10px_40px_-15px_rgba(0,0,0,0.5)]" data-id="element-527">
                <div className="w-14 h-14 bg-[#111] border border-white/5 rounded-2xl flex items-center justify-center mb-8 group-hover:border-brand-orange/30 group-hover:bg-brand-orange/5 transition-colors duration-500 relative overflow-hidden" data-id="element-528">
                  <div className="absolute inset-0 bg-brand-orange/20 blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-529" />
                  <card.icon className="w-6 h-6 text-gray-400 group-hover:text-brand-orange transition-colors duration-500 relative z-10" data-id="element-530" />
                </div>
                <h3 className="text-xl font-medium text-white mb-4 tracking-tight" data-id="element-531">
                  {card.title}
                </h3>
                <p className="text-gray-400 leading-relaxed text-sm" data-id="element-532">
                  {card.description}
                </p>
              </div>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
}